// Unpublished Work © 2025 Deere & Company.

import t from 'tcomb';

export const RemoveVisibilityError = t.struct({
    hasError: t.Boolean,
    errorMessage: t.String
}, {
    defaultProps: {
        hasError: false,
        errorMessage: ''
    },
    name: 'removeVisibilityError',
    strict: true
});
